import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import PlatformViewLoader from './platform/PlatformViewLoader.tsx';
import SupportPage from '@/pages/SupportPage.tsx';
import './ModuleTabs.css';

interface ModuleTabsProps {
  onLogout: () => Promise<void>;
}

// message-circle with question mark inside
const SupportIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
    <path d="M12 17h.01"/>
  </svg>
);

// log-out arrow pointing right out of a door
const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block' }}>
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
    <polyline points="10 17 15 12 10 7"/>
    <line x1="15" y1="12" x2="3" y2="12"/>
  </svg>
);

const ModuleTabs: React.FC<ModuleTabsProps> = ({ onLogout }) => {
  const { user } = useAuth();
  const [activePlatformId, setActivePlatformId] = useState<string | null>(null);
  const [showSupport, setShowSupport] = useState(false);

  React.useEffect(() => {
    if (user?.platforms && user.platforms.length > 0 && !activePlatformId) {
      setActivePlatformId(user.platforms[0].id);
    }
  }, [user, activePlatformId]);

  const handleSupport = () => {
    setShowSupport(true);
  };

  if (!user?.platforms || user.platforms.length === 0) {
    return (
      <div className="no-modules">
        <p>Модули</p>
        <p>Няма активирани модули за този потребител.</p>
        <div className="header-actions">
          <button onClick={handleSupport} className="support-button" title="Докладвай проблем">
            <SupportIcon />
          </button>
          <button onClick={onLogout} className="logout-button" title="Изход">
            <LogoutIcon />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="module-tabs-container">
      <div className="tabs-header">
        <div className="tabs-list">
          {user.platforms.map((platform) => (
            <button
              key={platform.id}
              className={`tab-button ${!showSupport && activePlatformId === platform.id ? 'active' : ''}`}
              onClick={() => { setActivePlatformId(platform.id); setShowSupport(false); }}
            >
              {platform.name}
            </button>
          ))}
        </div>
        <div className="header-actions">
          <button
            onClick={handleSupport}
            className={`support-button ${showSupport ? 'active' : ''}`}
            title="Докладвай проблем"
          >
            <SupportIcon />
          </button>
          <button onClick={onLogout} className="logout-button" title="Изход">
            <LogoutIcon />
          </button>
        </div>
      </div>

      <div className="tab-content">
        {showSupport && <SupportPage onClose={() => setShowSupport(false)} />}
        {user.platforms.map((platform) => (
          <div
            key={platform.id}
            className="platform-tab-panel"
            style={{ display: !showSupport && activePlatformId === platform.id ? 'block' : 'none' }}
          >
            <PlatformViewLoader platformId={platform.id} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModuleTabs;
